var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  var l0 = _vm.__map(_vm.tralvelList, function(item, __i0__) {
    var m0 = _vm.dateFormat(item.createTime)
    return {
      $orig: _vm.__get_orig(item),
      m0: m0
    }
  })

  var l1 = _vm.__map(_vm.tralvelList, function(item, __i2__) {
    var m1 = _vm.$getImg(item.coverPlanUrl)
    var m2 = _vm.dateFormat(item.createTime)
    return {
      $orig: _vm.__get_orig(item),
      m1: m1,
      m2: m2
    }
  })

  _vm.$mp.data = Object.assign(
    {},
    {
      $root: {
        l0: l0,
        l1: l1
      }
    }
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }